import { createContext, useReducer, useContext } from 'react'

interface IAuthStateType {
  isLoggedIn: boolean
  user: any
  showSwitchNetworkModal: boolean
  disableNetworkOptions: boolean
}

const storedAuthStateJson = sessionStorage.getItem('authState') || localStorage.getItem('authState')
const storedAuthState = storedAuthStateJson ? JSON.parse(storedAuthStateJson) : null

const initialAuthState = storedAuthState || {
  isLoggedIn: false,
  user: null,
  showSwitchNetworkModal: false,
  disableNetworkOptions: false,
}

interface IauthAction {
  type:
    | 'LOGIN'
    | 'LOGOUT'
    | 'UPDATE_TOKEN'
    | 'REGISTER'
    | 'SWITCHREMEMBER'
    | 'SWITCHNETWORKMODAL'
    | 'DISABLENETWORKOPTIONS'
    | null
  payload: any
}

export const AuthContext = createContext(initialAuthState)
export const AuthDispatchContext = createContext({} as any)

const authReducer = (state: IAuthStateType, action: IauthAction) => {
  const { type, payload } = action
  switch (type) {
    case 'LOGIN':
      const loggedInState = {
        ...state,
        isLoggedIn: true,
        user: payload,
      }
      if (loggedInState.user.rememberMe) {
        localStorage.setItem('authState', JSON.stringify(loggedInState))
        sessionStorage.removeItem('authState')
      } else {
        sessionStorage.setItem('authState', JSON.stringify(loggedInState))
        localStorage.removeItem('authState')
      }
      return loggedInState
    case 'LOGOUT':
      const loggedOutState = {
        ...state,
        isLoggedIn: false,
        user: null,
      }
      sessionStorage.removeItem('authState')
      localStorage.removeItem('authState')

      return loggedOutState
    case 'UPDATE_TOKEN':
      const newState = {
        ...state,
        user: { ...state.user, accessToken: payload.accessToken },
      }
      return newState
    case 'REGISTER':
      return state
    case 'SWITCHREMEMBER':
      const newRememberState = {
        ...state,
        remember: payload,
      }
      return newRememberState
    case 'SWITCHNETWORKMODAL':
      const newSwitchNetworkModalState = {
        ...state,
        showSwitchNetworkModal: payload,
      }
      return newSwitchNetworkModalState
    case 'DISABLENETWORKOPTIONS':
      const newDisableNetworkState = {
        ...state,
        disableNetworkOptions: payload,
      }
      return newDisableNetworkState
    default:
      return state
  }
}

export const AuthProvider = ({ children }: any) => {
  const [authState, authDispatch] = useReducer(authReducer, initialAuthState)

  return (
    <AuthContext.Provider value={authState}>
      <AuthDispatchContext.Provider value={authDispatch}>{children}</AuthDispatchContext.Provider>
    </AuthContext.Provider>
  )
}

export function useAuthState() {
  return useContext(AuthContext)
}

export function useAuthDispatch() {
  return useContext(AuthDispatchContext)
}
